import { render, staticRenderFns } from "./order-return.vue?vue&type=template&id=4d219206&scoped=true"
import script from "./order-return.vue?vue&type=script&lang=js"
export * from "./order-return.vue?vue&type=script&lang=js"
import style0 from "./order-return.vue?vue&type=style&index=0&id=4d219206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0_supports-color@_e2va3oitd2br7adsazclseazuu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d219206",
  null
  
)

export default component.exports